<script lang="ts">
	import type { Device } from 'src/types/Device';
	import ZonesList from './ZonesList.svelte';
	import ZonesCanvas from '../../CameraPlayer/ZonesCanvas.svelte';
	import VideoContainer from '../../CameraPlayer/VideoContainer.svelte';
	import WebRTCPlayer from '../../CameraPlayer/WebRTCPlayer.svelte';
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { user_data } from 'src/stores/account/user';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getCameraZones } from '../../helpers/camera-zone-helpers';

	export let device: Device;

	const realId = real_id(device.id);

	$: settingsStore = getDeviceSettings(realId);
	$: device_settings = $settingsStore;
	$: cameraZones = getCameraZones(device_settings).filter((zone) => zone.enable);
	// A Support Access session may not open a stream, so the zone canvas keeps
	// the container's empty background instead of a live frame.
	$: canPlayStream = $user_data?.temporary !== true;
</script>

<div class="mb-s">
	<ZonesCanvas zones={cameraZones}>
		<VideoContainer isZoomable={false}>
			{#if canPlayStream}
				<WebRTCPlayer deviceId={device.id} showControls={false} previewSize="medium" />
			{/if}
		</VideoContainer>
	</ZonesCanvas>
</div>

<ZonesList {device} />
